import "./Hero.scss";
import Image from "../../../Components/Image/Image";
import { Assest } from "../../../Components/Assest/Assest";

function Hero() {
  return (
    <div>
      <div className="section hero">
        <div className="col typography">
          <h1 className="title">What Are We About</h1>
          <p className="info">
            FoodiesHub is a place where you can please your soul and tummy with
            delicious food recepies of all cuisine. And our service is
            absolutely free. So start exploring now.
          </p>
          <button className="btn">EXPLORE NOW</button>
        </div>
        <div className="col gallery">
          {Assest.map((src, index) => (
            <Image key={index} imgSrc={src.img} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Hero;
